export default "__VITE_ASSET__Cf98ZNGZ__"